import { Component, Suspense, useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { animateElements } from '../lib/motion.js';
import { attachMagneticButtons } from '../lib/magneticButtons.js';
import '../css/magnetic-buttons.css';
import '../css/navigation-motion.css';
import FullScreenLoader from './FullScreenLoader.jsx';

class RouteErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidUpdate(previous) {
    if (previous.path !== this.props.path && this.state.failed) this.setState({ failed:false });
  }

  render() {
    if (this.state.failed) {
      return (
        <section className="app-card" role="alert" style={{ padding: '1.5rem' }}>
          <h2>No se pudo cargar la pantalla</h2>
          <p>Comprueba tu conexión y recarga para volver a intentarlo.</p>
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>Recargar pantalla</button>
        </section>
      );
    }
    return this.props.children;
  }
}

export default function RouteContent({ children }) {
  const { pathname } = useLocation();
  const root = useRef(null);
  const previousPath = useRef(pathname);
  useLayoutEffect(() => attachMagneticButtons(root.current), []);
  useLayoutEffect(() => {
    const tab = previousPath.current.split('/')[1] === pathname.split('/')[1];
    previousPath.current = pathname;
    const cancel = animateElements([root.current], [
      {opacity:tab ? 1 : .96, transform:`translateY(${tab ? 2 : 4}px)`}, {opacity:1,transform:'none'},
    ], {duration:tab ? 700 : 800,easing:'cubic-bezier(.4,0,.2,1)'});
    return cancel;
  }, [pathname]);
  return (
    <div ref={root} className="route-content" data-route-path={pathname}><RouteErrorBoundary path={pathname}>
      <Suspense fallback={<FullScreenLoader active message="Cargando pantalla..." />}>
        {children}
      </Suspense>
    </RouteErrorBoundary></div>
  );
}
